import { Box, Flex } from '@chakra-ui/react'
import React from 'react'
import { useSettingsState } from '~/atoms/SettingsState'
import { ChannelBadge } from '~/components/ChannelBadge'
import { usePartnerLogo } from '~/hooks/useCurrentPartner'

import { AccountButton } from './AccountButton'
import { ActionsButton } from './ActionsButton'
import { useTopNavStyle } from './componentStyles'
import { ConnectionStatusChip } from './ConnectionStatusChip'
import { DoNotDisturbSplitButton } from './DoNotDisturbSplitButton'
import { EnvironmentLabel } from './EnvironmentLabel'
import { PbxHeaderSwitcher } from './PbxHeaderSwitcher'
import { QueueControlButton } from './QueueControlButton'

export const TopNav = () => {
  const {
    settings: {
      callCenter: { isEnabled: queueEnabled },
      webPhone: { isEnabled: webPhoneEnabled },
    },
  } = useSettingsState()
  const partnerLogo = usePartnerLogo()
  const styles = useTopNavStyle({ logo: partnerLogo })

  return (
    <Flex css={styles.banner}>
      <Flex alignItems={'center'}>
        <Box css={styles.logo} />
        <ChannelBadge />
      </Flex>
      <EnvironmentLabel />
      <Flex css={styles.rightButtons}>
        <PbxHeaderSwitcher />
        <ActionsButton />
        {!queueEnabled && <DoNotDisturbSplitButton />}
        {queueEnabled && webPhoneEnabled && <QueueControlButton />}
        <ConnectionStatusChip />
        <AccountButton />
      </Flex>
    </Flex>
  )
}
